// Layout Components
import Sidebar from './Sidebar';
import Header from './Header';

export default function DashboardLayout({ children }) {
  return (
    <div className="flex h-screen bg-gray-50 dark:bg-slate-900 font-sans transition-colors duration-200">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 flex flex-col overflow-x-hidden overflow-y-scroll bg-gray-50 dark:bg-slate-900 p-6 text-sm transition-colors duration-200">
          <div className="flex-1">
            {children}
          </div>
          <footer className="mt-8 text-center text-gray-400 dark:text-slate-500 text-xs py-4 border-t border-gray-200 dark:border-slate-800 transition-colors duration-200">
            Copyright © 2026 Sapient Rank. All rights reserved. | <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer" className="hover:text-gray-600 dark:hover:text-slate-300 transition-colors">京ICP备2026014122号-2</a>
          </footer>
        </main>
      </div>
    </div>
  );
}
